import { useAppSelector } from "@/stores/hook";
import {
  selectAccessConfig,
  selectIsTenantAdmin,
  selectPresetRole,
  selectRbacContext,
} from "@/rbac/rbacSlice";
import {
  COUPON_PERMISSION_MODULE,
  effectiveCouponControl,
} from "@/rbac/couponAccess";

/**
 * May the signed-in user manage coupon codes / apply them on deals? Mirrors the
 * server's `hasCouponPermission` exactly (tenant admin bypass, saved value,
 * else the role preset's default) so a control is shown iff the API allows it.
 */
export function useCouponPermissions(): {
  canManage: boolean;
  canApply: boolean;
} {
  const accessConfig = useAppSelector(selectAccessConfig);
  const isTenantAdmin = useAppSelector(selectIsTenantAdmin);
  const ctx = useAppSelector(selectRbacContext);
  const presetRole = useAppSelector(selectPresetRole);

  if (isTenantAdmin || ctx?.systemRole === "TENANT_ADMIN") {
    return { canManage: true, canApply: true };
  }
  const saved = (
    accessConfig?.global as
      | Record<string, Record<string, unknown> | undefined>
      | undefined
  )?.[COUPON_PERMISSION_MODULE];
  return {
    canManage: effectiveCouponControl(saved, presetRole, "manage") === "allow",
    canApply: effectiveCouponControl(saved, presetRole, "apply") === "allow",
  };
}
